import { render, staticRenderFns } from "./AppPlaca.vue?vue&type=template&id=0ea8b22c&scoped=true"
import script from "./AppPlaca.vue?vue&type=script&lang=js"
export * from "./AppPlaca.vue?vue&type=script&lang=js"
import style0 from "./AppPlaca.vue?vue&type=style&index=0&id=0ea8b22c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea8b22c",
  null
  
)

export default component.exports